(function () {
	angular
		.module('trackeye')
		.factory('Logger', _LoggerFactory);

	_LoggerFactory.$inject = ['$injector'];

	function _LoggerFactory($injector) {

		function Logger(name, callback) {
			this.name = name;
			this.callback = callback;
			this.handleFn = undefined;
			this.resolved = false;

			try {
				this.handleFn = $injector.get(name + 'Logger');
				this.resolved = true;
			} catch (e) {
				console.warn("Logger::" + name + " could not be injected");
				console.warn(e);
				this.handleFn = undefined;
			}
		}

		Logger.prototype.exec = function (data) {
			return new this.handleFn(data);
		};

		Logger.prototype.isResolved = function () {
			return this.resolved;
		};

		Logger.prototype.hasCallback = function () {
			return (typeof this.callback === "function");
		};

		Logger.prototype.execCallback = function (data) {
			this.callback(data);
		};

		return Logger;
	}
})();